import React, { useContext } from 'react'

import { Trans, useTranslation } from 'react-i18next'

import Dialog from '@components/shared/Dialog'
import { TitleContext } from '@providers/TitleProvider'
import { SUPPORT_EMAIL } from '@utils/global'

const NoSoundCheckDialog: React.FC = () => {
  const { t } = useTranslation()
  const { title } = useContext(TitleContext)
  return (
    <Dialog
      name="no_soundcheck"
      maxWidth={364}
      title={t('content.scNotAvailable', { context: 'title' })}>
      <p className="mb-4">
        <Trans
          i18nKey="messages.scNotAvailable"
          components={[
            <br key={0} />,
            <button
              key={1}
              className="orange-link mx-1"
              onClick={() => {
                window.location.href = `mailto:${SUPPORT_EMAIL}?subject=${t(
                  'content.scNotAvailable',
                  { context: 'title' }
                )}: ${title.title}`
              }}
              title="contact support">
              contact support
            </button>,
          ]}
        />
      </p>
    </Dialog>
  )
}
export default NoSoundCheckDialog
